import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import PageHero from './components/PageHero'
import { getPress } from '../data/loadData'
import { cleanHtml } from '../data/html'
import './Pages.css'

const TILTS = ['-1.2deg', '0.8deg', '-0.4deg', '1.3deg', '-0.9deg', '0.5deg']

function parseClipping(item, order) {
  const label = `${item.oyun || ''} ${item.topluluk || ''}`.replace(/\s+/g, ' ').trim()
  const editionMatch = label.match(/(\d+)\.\s*ETHOS/i)
  const source = label
    .replace(/\d+\.\s*ETHOS/gi, ' ')
    .replace(/\bETHOS\b/gi, ' ')
    .replace(/(^|\s)haber(?=\s|$)/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  const html = cleanHtml(item.aciklama)
  return {
    key: item.id,
    order,
    edition: editionMatch ? Number(editionMatch[1]) : null,
    source: source || 'Haber',
    image: item.afis ? `images/${item.afis}` : '',
    html,
  }
}

export default function Press() {
  const clippings = useMemo(() => getPress()
    .map(parseClipping)
    .sort((a, b) => (b.edition || 0) - (a.edition || 0) || a.order - b.order), [])

  const [active, setActive] = useState(null)
  const dialogRef = useRef(null)
  const current = active === null ? null : clippings[active]

  const step = useCallback((delta) => {
    setActive((index) => (index === null ? index : (index + delta + clippings.length) % clippings.length))
  }, [clippings.length])

  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return
    if (current && !dialog.open) dialog.showModal()
    if (!current && dialog.open) dialog.close()
  }, [current])

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault()
      setActive(null)
    }
    if (event.key === 'ArrowRight') step(1)
    if (event.key === 'ArrowLeft') step(-1)
  }

  const onBackdrop = (event) => {
    if (event.target === dialogRef.current) setActive(null)
  }

  const textCount = clippings.filter((clip) => clip.html).length

  return (
    <React.Fragment>
      <Header />
      <PageHero
        eyebrow='Ethos Ankara Tiyatro Festivali'
        title='Basında'
        lede={`Gazete, dergi ve çevrimiçi yayınlarda festivalden ${clippings.length} haber; ${textCount} tanesinin tam metni de burada.`}
      />

      <div className='pg' lang='tr'>
        <section className='pg-sun pg-block' aria-label='Basın kupürleri'>
          <div className='container'>
            <ul className='pr-wall'>
              {clippings.map((clip, index) => (
                <li key={clip.key} className='pr-item'>
                  <button
                    type='button'
                    className='pr-open'
                    onClick={() => setActive(index)}
                    aria-label={`${clip.source}${clip.edition ? `, ${clip.edition}. Ethos` : ''} haberini büyüt`}
                  >
                    <span className='pr-clip' style={{ '--pr-tilt': TILTS[index % TILTS.length] }}>
                      <img src={clip.image} alt='' loading='lazy' />
                      {clip.edition ? <span className='pr-edition'>{clip.edition}.</span> : null}
                    </span>
                    <span className='pr-caption'>
                      <span className='pr-source'>{clip.source}</span>
                      <span className='pr-kind'>
                        {[clip.edition ? `${clip.edition}. Ethos` : '', clip.html ? 'Tam metin' : ''].filter(Boolean).join(' · ')}
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </div>

      <dialog
        ref={dialogRef}
        className='pg pr-viewer'
        lang='tr'
        aria-label={current ? current.source : 'Haber'}
        onClose={() => setActive(null)}
        onClick={onBackdrop}
        onKeyDown={onKeyDown}
      >
        {current ? (
          <div className={`pr-viewer-inner${current.html ? ' has-text' : ''}`}>
            <div className='pr-viewer-bar'>
              <p className='pr-viewer-title'>
                <strong>{current.source}</strong>
                <span className='pr-viewer-count'>
                  {current.edition ? `${current.edition}. ETHOS · ` : ''}{active + 1} / {clippings.length}
                </span>
              </p>
              <button type='button' className='pr-viewer-btn' onClick={() => step(-1)} aria-label='Önceki haber'>←</button>
              <button type='button' className='pr-viewer-btn' onClick={() => step(1)} aria-label='Sonraki haber'>→</button>
              <button type='button' className='pr-viewer-btn' onClick={() => setActive(null)} aria-label='Kapat'>✕</button>
            </div>
            <div className='pr-viewer-media'>
              <img src={current.image} alt={`${current.source} haber kupürü`} />
            </div>
            {current.html ? (
              <div className='pr-viewer-text'>
                <div className='pg-prose' dangerouslySetInnerHTML={{ __html: current.html }} />
              </div>
            ) : null}
          </div>
        ) : null}
      </dialog>
      <Footer />
    </React.Fragment>
  )
}
